import React, { useContext } from 'react'
import Drawer from '@material-ui/core/Drawer'
import TuneIcon from '@material-ui/icons/Tune'
import LocationOnIcon from '@material-ui/icons/LocationOn'
import PersonIcon from '@material-ui/icons/Person'
import WorkIcon from '@material-ui/icons/Work'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import ListAltIcon from '@material-ui/icons/ListAlt'
import NearMeIcon from '@material-ui/icons/NearMe'
import ApartmentIcon from '@material-ui/icons/Apartment'
import getAllFilter from './GetAllFilters'
import PropertyTypeFilter from '../PropertyTypeFilter/PropertyTypeFilter'
import FeaturesFilter from '../FeaturesFilter/FeaturesFilter'
import AccountFilter from '../AccountFilter/AccountFilter'
import LoanFilter from '../LoanFilter/LoanFilter'
import SalesFilter from '../SalesFilter/SalesFilter'
import TenantInfoFilter from '../TenantInfoFilter/TenantInfoFilter'
import DistanceFilter from '../DistanceFilter/DistanceFilter'
import ListingStatusFilter from '../ListingStatusFilter/ListingStatusFilter'
import HomeIcon from '@material-ui/icons/Home'
import SubmitClearFilters from '../SubmitClearFilters/SubmitClearFilters'
import LocationFilters from '../LocationFilters/LocationFilters'
import myContext from '../context/context'
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined'
import { sortArray } from '../../../PropertyList/Utility/PropertyListUtility'

const SideDrawer = () => {

  const [state, setState] = React.useState({
    'right': false
  })

  const { searchCriteria, searchResult, preSearchCriteria } = useContext(myContext)

  const [listAllFilters, setListAllFilters] = React.useState(sortArray(getAllFilter, 'order', 'asc'))

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return
    }
    setState({ ...state, [anchor]: open })
  }

  const handleClose = () => {
    setState({ ...state, 'right': false })
  }

  const listOfIcons = {
    HomeIcon: <HomeIcon />,
    LocationOnIcon: <LocationOnIcon />,
    PersonIcon: <PersonIcon />,
    MonetizationOnIcon: <MonetizationOnIcon />,
    WorkIcon: <WorkIcon />,
    AccountBalanceIcon: <AccountBalanceIcon />,
    ApartmentIcon: <ApartmentIcon />,
    ListAltIcon: <ListAltIcon />,
    NearMeIcon: <NearMeIcon />
    // FeaturesFilter: <FeaturesFilter />
    // LocationFilter: <LocationFilter />
  }

  const toggleAccordion = item => {
    const i = listAllFilters.findIndex(x => x.componentName === item.componentName)

    const newlistAllFilters = [...listAllFilters]
    newlistAllFilters[i] = { ...newlistAllFilters[i], show: !newlistAllFilters[i].show }
    if (newlistAllFilters[i].show) {
      newlistAllFilters[i] = { ...newlistAllFilters[i], arrow: 'rotate(0)' }
    } else {
      newlistAllFilters[i] = { ...newlistAllFilters[i], arrow: 'rotate(180)' }
    }
    setListAllFilters(newlistAllFilters)
  }

  const listOfFilterComponent = {
    PropertyTypeFilter: <PropertyTypeFilter />,
    FeaturesFilter: <FeaturesFilter />,
    TenantInfoFilter: <TenantInfoFilter />,
    SalesFilter: <SalesFilter />,
    LocationFilter: <LocationFilters />,
    LoanFilter: <LoanFilter />,
    AccountFilter: <AccountFilter />,
    DistanceFilter: <DistanceFilter />,
    ListingStatusFilter: <ListingStatusFilter />
  }

  const showFilterComponent = item => {
    let returnVal = true

    if (item === 'DistanceFilter' && searchCriteria.distanceFields.length === 0) {
      returnVal = false
    }

    if (item === 'LocationFilter' && (searchResult.property.length === 0 || preSearchCriteria.searchType === 'prospecting')) {
      returnVal = false
    }

    if (item === 'LoanFilter' && (preSearchCriteria.searchType !== 'prospecting')) {
      returnVal = false
    }

    if (item === 'AccountFilter' && (preSearchCriteria.searchType !== 'prospecting')) {
      returnVal = false
    }

    return returnVal
  }

  const showBadge = item => {
    let returnVal = 0

    returnVal = searchCriteria[item].length

    return returnVal
  }

  return (
    <div>
      {['right'].map(anchor => (
        <React.Fragment key={anchor}>
          <button data-testid="button-all-filters" className="btn btn-primary btn-outline-primary border-1 btn-sm hover:text-white py-1 rounded-pill" onClick={toggleDrawer('right', true)}>
            <span className="px-1"><TuneIcon /></span>
            <span className="px-2">All Filters</span>
          </button>
          <Drawer data-testid="drawer-all-filters" anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            <>
              <div className="flex flex-col h-screen">
                <div className="border-base border-b-1">
                  <div className="p-6 flex justify-between align-middle drawer-w mr-2">
                    <div>
                      <TuneIcon />
                      <span className="px-4">All filters</span>
                    </div>
                    <div className="cursor-pointer"><a data-testid="test-close-Drawer" onClick={handleClose}> <ClearOutlinedIcon /> </a></div>
                  </div>
                </div>
                <div className="h-4\/5 overflow-y-auto disable-scrollbars">
                  {listAllFilters.map((value, index) => {
                    return (
                      <>
                        {showFilterComponent(value.componentName) ?
                          <div className="drawer-w border-base border-b-1">
                            <div key={index} className="py-6 flex flex-col my-1" >
                              <div data-testid={`test-div-${value.header}`} className="flex justify-between px-6 cursor-pointer" onClick={() => toggleAccordion(value)}>
                                <div >
                                  <span>{listOfIcons[value.startIcon]}</span>
                                  <span className="px-4">{value.header}</span>
                                  {showBadge(value.searchFieldTitle) !== 0 ?
                                    <span className="badge rounded-pill items-center bg-gray-15 text-1">{showBadge(value.searchFieldTitle)}</span> : null}
                                </div>
                                <div>
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-auto" transform={value.arrow}>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12 8.30849L20.7197 17.0274C21.0126 17.3203 21.4875 17.3202 21.7804 17.0273C22.0732 16.7344 22.0732 16.2595 21.7803 15.9667L12.9665 7.15366C12.8397 7.02668 12.6889 6.92583 12.5231 6.85708C12.3573 6.78832 12.1795 6.75293 12 6.75293C11.8205 6.75293 11.6427 6.78832 11.4769 6.85708C11.3111 6.92583 11.1605 7.02657 11.0336 7.15355L2.21969 15.9667C1.92679 16.2595 1.92677 16.7344 2.21965 17.0273C2.51252 17.3202 2.9874 17.3203 3.28031 17.0274L12 8.30849Z" fill="black" />
                                  </svg>
                                </div>
                              </div>
                              {value.show ? <div data-testid={`div-${value.componentName}`} className="pt-6 pl-8 pr-6">
                                {listOfFilterComponent[value.componentName]}
                              </div> : null}
                            </div>
                          </div>
                          : null}
                      </>
                    )
                  })}
                </div>
                <div className="mt-auto">
                  <div className="border-base border-t-1">
                    <SubmitClearFilters handleClose={handleClose} criteriaToApply="all"></SubmitClearFilters>
                  </div>
                </div>
              </div>
            </>
            {/* {list(anchor)} */}
          </Drawer>
        </React.Fragment>
      ))
      }
    </div >
  )
}

export default SideDrawer
